const autocompleteActionModalFilter = {
  sites: 'Sites',
  users: 'Responsáveis',
  equipments: 'Tipo de Equipamento',
  place: 'Local',
  areas: 'Departamentos',
  status: 'Status Ações',
  statusMaintenances: 'Status Manutenções',
  maintenanceCreatedBy: 'Manutenção Criada por',
};

export default autocompleteActionModalFilter;
